export default __webpack_public_path__ + "static/media/eagle wibs 2.07e2f01b.png";